/**Roles of a user */

export default {
  SUPER_ADMIN: 'super admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  REPORTING: 'reporting',
};
